import { useEffect, useLayoutEffect, useRef, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { CommonErrorAlert } from "../Commonalert/commonErrorAlert";

export function useUserActivity(pageName) {
    const navigate = useNavigate();
    const esodata = useSelector((state) => state);
    const ApiToken = esodata.apiauthkey.value;
    const location = useLocation();
    const inTime = useRef({ status: false });
    const [apiopen, setapiOpen] = useState(false);
    const [apierrorMsg, setapierrorMsg] = useState();
    const [startTime, setStartTime] = useState(new Date().toLocaleTimeString());
    const [endTime, setEndTime] = useState(new Date().toLocaleTimeString());

    // useEffect(() => {
    //     let lastActive = Date.now();
    //     let isActive = true;

    //     const updateActivity = () => {
    //         if (!isActive) {
    //             lastActive = Date.now();
    //             isActive = true;
    //             console.log("active", new Date().toLocaleTimeString());
    //             setStartTime(new Date().toLocaleTimeString());
    //             // saveUserActivity(new Date().toLocaleTimeString(), endTime, 'active:');
    //         }
    //     };

    //     const handleVisibilityChange = () => {
    //         if (document.hidden) {
    //             if (isActive) {
    //                 isActive = false;
    //                 // console.log("Dashboard tab change", new Date().toLocaleTimeString());
    //                 saveUserActivity(startTime, new Date().toLocaleTimeString(), 'Dashboard tab change:');
    //             }
    //         } else {
    //             updateActivity();
    //         }
    //     };

    //     const checkInactivity = setInterval(() => {
    //         if (Date.now() - lastActive > 10000) {
    //             if (isActive) {
    //                 isActive = false;
    //                 // console.log("Dashboard 10sec inactive", new Date().toLocaleTimeString());
    //                 const timestamp = lastActive; // 1696567890123
    //                 const timeString = new Date(timestamp).toLocaleTimeString();
    //                 saveUserActivity(startTime, new Date().toLocaleTimeString(), 'Dashboard 10sec inactive:');
    //             }
    //         }
    //     }, 1000);

    //     window.addEventListener("mousemove", updateActivity);
    //     window.addEventListener("keydown", updateActivity);
    //     window.addEventListener("visibilitychange", handleVisibilityChange);

    //     return () => {
    //         window.removeEventListener("mousemove", updateActivity);
    //         window.removeEventListener("keydown", updateActivity);
    //         window.removeEventListener("visibilitychange", handleVisibilityChange);
    //         clearInterval(checkInactivity);
    //     };
    // }, []);

    // // Track pageName leave
    // useLayoutEffect(() => {
    //     return () => {
    //         if (inTime.current.status) {
    //             // console.log("User leaving pageName: ", new Date().toLocaleTimeString());
    //             saveUserActivity(startTime, new Date().toLocaleTimeString(), 'User leaving pageName:');
    //         }
    //     };
    // }, [location.pathname]);

    // // Track pageName enter
    // useEffect(() => {
    //     inTime.current.status = true;
    //     console.log("User entered pageName:", new Date().toLocaleTimeString());
    //     setStartTime(new Date().toLocaleTimeString());
    //     // saveUserActivity(new Date().toLocaleTimeString(), endTime, 'User entered pageName:');
    // }, []);



    const lastActiveRef = useRef(new Date());
    const currentActiveRef = useRef(Date.now());
    const isActiveRef = useRef(false);
    const hasMounted = useRef(false);

    useLayoutEffect(() => {
        return () => {
            if (hasMounted.current) {
                // 🚀 call leave API once
                saveUserActivity(lastActiveRef, new Date(), 'User leaving ' + pageName + ' pageName:');
            }
        };
    }, [pageName]);

    useEffect(() => {
        if (!hasMounted.current) {
            setTimeout(() => {
                hasMounted.current = true;
            }, 2000);
            // 🚀 call enter API once
            lastActiveRef.current = new Date();
            // console.log("User entered " + pageName + " pageName:", new Date().toLocaleTimeString());
        }
    }, [pageName]);


    const updateActivity = () => {
        // console.log('activeboolean', isActiveRef.current);
        currentActiveRef.current = Date.now();
        if (!isActiveRef.current) {
            lastActiveRef.current = new Date();
            isActiveRef.current = true;
            // console.log(pageName + " active", new Date().toLocaleTimeString());
            // saveUserActivity(new Date().toLocaleTimeString(), endTime, 'active:');
        }
    };

    const handleVisibilityChange = () => {
        if (document.hidden) {
            if (isActiveRef.current) {
                isActiveRef.current = false;
                // console.log("Dashboard tab change", new Date().toLocaleTimeString());
                saveUserActivity(lastActiveRef, new Date(), pageName + ' tab change:');
            }
        } else {
            updateActivity();
        }
    };

    useEffect(() => {
        const checkInactivity = setInterval(() => {
            if (Date.now() - currentActiveRef.current > 10000) {
                if (isActiveRef.current) {
                    isActiveRef.current = false;
                    // console.log("Dashboard 10sec inactive", new Date().toLocaleTimeString());
                    saveUserActivity(lastActiveRef, new Date(), pageName + ' 10sec inactive:');
                }
            }
        }, 1000);

        window.addEventListener("mousemove", updateActivity);
        window.addEventListener("keydown", updateActivity);
        window.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            window.removeEventListener("mousemove", updateActivity);
            window.removeEventListener("keydown", updateActivity);
            window.removeEventListener("visibilitychange", handleVisibilityChange);
            clearInterval(checkInactivity);
        };
    }, [pageName]);


    // Track pageName leave
    // useLayoutEffect(() => {
    //     return () => {
    //         if (inTime.current.status) {
    //             // console.log("User leaving pageName:", leave.toLocaleTimeString());
    //             saveUserActivity(lastActiveRef, new Date().toLocaleTimeString(), 'User leaving' + pageName + ' pageName:');
    //         }
    //     };
    // }, [location.pathname]);

    // Track pageName enter
    // useEffect(() => {
    //     inTime.current.status = true;
    //     console.log("User entered " + pageName + " pageName:", new Date().toLocaleTimeString());
    // }, []);



    const saveUserActivity = async (sTime, eTime, event) => {
        const timestamp = sTime.current; // 1696567890123
        const timeString = new Date(timestamp).toLocaleTimeString();
        // console.log('time for the ' + event + ' startTime: ' + timeString + ' endTime: ' + eTime.toLocaleTimeString());
        // setStartTime(sTime);
        // setEndTime(eTime);

        var datavar = `${process.env.REACT_APP_API_URL}user_analytics/visit_link/`
        await axios.post(
            datavar,
            {
                "start_time": sTime.current,
                "end_time": eTime,
                "count": 1,
                "display_name": pageName,
                "event": 'time for the ' + event + ' startTime: ' + timeString + ' endTime: ' + eTime.toLocaleTimeString()
            },
            {
                headers: {
                    Authorization: `${ApiToken}`,
                },
            }
        ).catch((error) => {
            if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
                setapiOpen(true);
                setapierrorMsg(error?.response?.data?.error)
            }
            else if (error?.code == "ERR_NETWORK") {
                navigate('/errorpageNames')
            }
        });
    }

    const apihandleClose = () => {
        setapiOpen(false);
    };

    return (
        <CommonErrorAlert
            data={{
                apiopen: apiopen,
                apiErrorMsg: apierrorMsg,
                isIconStyled: true
            }}
            closeAlert={apihandleClose} />
    )
}
